<template>
  <div class="header" :class="{'test': !flag}">
    <div class="wrap">
      <div class="logo"><img src="../../assets/logo.png" alt=""></div>
      <div class="nav">
        <div>
          <!-- <router-link v-for="item in menuList" :key="item.id" @click.native="changeClass(item.id)"
            :to="item.routingAddress" exact>
            {{ item.title }}
          </router-link> -->
          <a v-for="(item, idx) in menuList" :key="item.id" @click="changeLinkClass(item, idx)"
            :class="{ 'router-link-exact-active': idx === activeIndex }">{{ item.title }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ApiWebMenu } from '../../api/index'
export default {
  name: 'headertemplate',
  data () {
    return {
      activeIndex: 0,
      menuList: [],
      flag: true
    }
  },
  mounted() {
    if (sessionStorage.getItem('menuIdx') !== '') {
      this.activeIndex = Number(sessionStorage.getItem('menuIdx'))
    }
  },
  created () {
    this.getMenuList()
  },
  methods: {
    changeLinkClass (item,idx) 
    {
      if (item.id === 1) {
        this.flag = true
      } else {
        this.flag = false
      }
      this.activeIndex =  idx
      this.$router.push({ path: item.routingAddress })
      sessionStorage.setItem('menuIdx', idx)
    },
    changeClass (id) {
      if (id === 1) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    getMenuList () {
      ApiWebMenu().then(({data}) => {
        if (data && data.status === 0) {
          this.menuList = data.data
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  @mainColor: #dc252B;
  @fuColor: #f2f2f2;
  @titleSubColor: #9F9E9E;
  a {
    text-decoration: none;
  }
  .header{
    // position: fixed;
    // left: 0;
    // top: 0px;
    // z-index: 999;
    width: 100%;
    height: 91px;
    // background: #ffffff;
    background: rgba(255, 255, 255, 0.7);
    // box-shadow: rgba(173, 170, 170, 0.7) 4px 4px 4px 4px;
    border-bottom: 1px solid #9F9E9E;
    position: fixed;
    z-index: 9999;
    top: 0;
    .wrap{
      width: 1552px;
      margin: 0 auto;
      display: flex;justify-content:flex-start;
      .logo{
        flex: 0 0 280px;
        padding-left: 40px;
        img{
          width: 182px;
          height: auto;
          margin-top: 29px;
        }
      }
      .nav{
        flex: 1;
        div {
          width: 876px;
          float: right;
          a{
            display: block;
            width: 96px;
            height: 88px;
            line-height: 88px;
            color: #333333;
            font-size: 18px;
            text-align: center;
            margin: 0 25px;
            float: left;
            border-bottom: 2px solid transparent;
            &:hover{
              cursor: default;
            }
          }
          a:hover,a.active,.router-link-exact-active{
            color: @mainColor;
            border-bottom: 2px solid @mainColor;
            font-weight: bold;
          }

        }
       
      }
    }
  }
  .test{
    background: #ffffff;
    .nav{
      a{
        color: #666666;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/template/header-template.vue